module.exports = __webpack_public_path__ + "img/asuka111-the-cat-caravan.0d81605.jpg";